export const COMPARE_HOME = '/home';
export const COMPARE_INFO = '/info';
export const CONTACT = '/contact';
export const COMPARE_MISSING_INFO = '/missing-info';
export const COMPARE_ADD_MISSING_INFO = '/add-missing-info';
export const COMPARE_NOT_POSSIBLE = '/compare-not-possible';
